// extracted by mini-css-extract-plugin
export default {"warning-icon":"sgIol","danger-icon":"EGB4f","new-rate-select":"qpJmV","table":"TZg8i"};